// extracted by mini-css-extract-plugin
module.exports = {"cont":"_93444fe79c--cont--2knne","title":"_93444fe79c--title--1jhnk"};